/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_DescriptionInputs */

const en_gc_resources_features_description = /** @type {(inputs: Gc_Resources_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft follows a recognisable spreadsheet workflow: edit cells, apply number formats, organise a table and build a chart. Its local calculation engine keeps the interaction close to your data. You can inspect the open-source project, choose a desktop package or try this hosted web build before installing anything.`)
};

const zh_gc_resources_features_description = /** @type {(inputs: Gc_Resources_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 采用熟悉的电子表格流程：编辑单元格、应用数字格式、组织表格、创建图表。本地计算引擎直接处理数据。你可以查看开源项目、选择桌面版，或在安装前试用本站托管的网页版本。`)
};

/**
* | output |
* | --- |
* | "GridCraft follows a recognisable spreadsheet workflow: edit cells, apply number formats, organise a table and build a chart. Its local calculation engine kee..." |
*
* @param {Gc_Resources_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_description = /** @type {((inputs?: Gc_Resources_Features_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_description(inputs)
	return zh_gc_resources_features_description(inputs)
});
export { gc_resources_features_description as "gc.resources.features.description" }